import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_reports_grid___ds_add_reports_to_context_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { context: string, allowed_reports?: { module_id: string, report_id: string }[], full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { module_id?: string, report_id?: string, title?: string, description?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.context)) {
      $missingRequiredInParams.push('\'context\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { context?: string, allowed_reports?: { module_id: string, report_id: string }[], full_text_search?: string, $keys: { module_id?: string, report_id?: string, title?: string }[] }): Promise<{ result?: { module_id?: string, report_id?: string, title?: string, description?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      context: string, allowed_reports?: { module_id: string, report_id: string }[], full_text_search?: string    }) {
        if(isNil($inParams.context)) {
          return true; 
        }
      return false;
    }
}
